import { render, staticRenderFns } from "./ModalRegionAdd.vue?vue&type=template&id=57bedd70&scoped=true"
import script from "./ModalRegionAdd.vue?vue&type=script&lang=js"
export * from "./ModalRegionAdd.vue?vue&type=script&lang=js"
import style0 from "./ModalRegionAdd.vue?vue&type=style&index=0&id=57bedd70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bedd70",
  null
  
)

export default component.exports